import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const Wrapper = styled.div`
	height: 20em;
	@media ${device.screen1680} {
		height: 18em;
	}
	@media ${device.screen1366} {
		height: 16em;
	}
	@media ${device.screen1280} {
		height: 14em;
	}
	@media ${device.screen1050} {
		height: 12em;
	}
	padding: 1rem;
	background-color: white;

	.p-datepicker {
		border: none !important;
		overflow: visible;
		.p-highlight {
			background-color: #01abc1 !important;
			border-radius: 10px;
			div {
				color: #fff;
			}
		}
	}

	.p-datepicker-calendar {
		height: auto;
		td {
			padding-left: 0;
			padding-right: 0;
			padding-top: 2px;
			padding-bottom: 2px;
		}
		th {
			padding-left: 0;
			padding-right: 0;
			padding-top: 2px;
			padding-bottom: 2px;
			margin-top: 0.5em !important;
			font-size: 0.75em;
		}
	}
	.p-component,
	.p-inputtext,
	.pi {
		font-size: 0.9em !important;
	}
	.p-datepicker-title {
		justify-content: start !important;
		line-height: normal !important;
		margin: 0 !important;

		.p-datepicker-month {
			margin-right: 0 !important;
			padding-right: 0 !important;
		}
		.p-link,
		.p-datepicker-decade {
			color: #01abc1 !important;
			font-family: 'Manrope-Bold';
			:focus {
				outline: none;
				border: none;
				box-shadow: none;
			}
		}
	}
	.p-datepicker-header {
		border: none !important;
		padding: 0 !important;
		position: relative;
		justify-content: start;
		gap: 5px;
	}
	.p-datepicker-prev {
		color: #01abc1 !important;
		width: auto !important;
		height: auto !important;
	}
	.p-datepicker-next {
		color: #01abc1 !important;
		width: auto !important;
		height: auto !important;
	}
	.p-datepicker table td > span {
		width: 2.5em !important;
		height: 2.5em !important;
		@media ${device.screen1680} {
			width: 2.2em !important;
			height: 2.2em !important;
		}
		@media ${device.screen1440} {
			width: 1.5em !important;
			height: 2em !important;
		}
		@media ${device.screen1366} {
			width: 1.5em !important;
			height: 1.8em !important;
		}
	}
	.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,
	.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
		padding: 5px;
		font-size: 15px !important;
		@media ${device.screen1680} {
			font-size: 14px !important;
		}
		@media ${device.screen1280} {
			font-size: 12.8px !important;
		}
		@media ${device.screen1050} {
			font-size: 11px !important;
		}
	}
	.date_area {
		font-size: 13px !important;
		@media ${device.screen1680} {
			font-size: 11px !important;
		}
		@media ${device.screen1280} {
			font-size: 9.8px !important;
		}
		@media ${device.screen1050} {
			font-size: 9px !important;
		}
	}
	.small__view__calender {
		.smallview__calendar__header {
			.p-datepicker-prev-icon {
				font-size: 12px !important;
			}
		}
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;
